import { render, staticRenderFns } from "./BookViewer.vue?vue&type=template&id=1c792944&"
import script from "./BookViewer.vue?vue&type=script&lang=ts&"
export * from "./BookViewer.vue?vue&type=script&lang=ts&"
import style0 from "./BookViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports